import { useState } from 'react';
import Kader from './Kader';
import type { Teksten } from '../teksten';
import { WISSELWOORD, isWisselwoord } from '../lib/wisselwoord';

/**
 * De plek van jouw taal is bezet.
 *
 * WAAROM EEN WOORD INTYPEN EN GEEN KNOP. Overnemen gooit het andere apparaat
 * uit het gesprek. Ben jij dat zelf, dan is dat precies wat je wilt. Is het de
 * ander die per ongeluk jouw taal koos, of iemand die de link doorgestuurd
 * kreeg, dan zet een knop die je even aantikt het gesprek op zijn kop. Een
 * woord typ je niet per ongeluk.
 */
export default function PlekBezet({
  t,
  opnieuw,
  neemOver,
  terug,
}: {
  t: Teksten;
  opnieuw: () => void;
  neemOver: () => void;
  terug: () => void;
}) {
  const [invoer, setInvoer] = useState('');
  const klopt = isWisselwoord(invoer);

  return (
    <Kader titel={t.plekBezetTitel}>
      <p className="text-sm text-slate-650 mb-4">{t.plekBezetUitleg}</p>
      <button
        type="button"
        onClick={opnieuw}
        className="w-full py-2.5 rounded-xl bg-gio-blue hover:bg-gio-dark text-white
                   font-bold text-sm transition-colors duration-155"
      >
        {t.probeerOpnieuw}
      </button>

      <form
        className="mt-5 pt-4 border-t-2 border-slate-150"
        onSubmit={(e) => {
          e.preventDefault();
          if (klopt) neemOver();
        }}
      >
        <p className="text-sm text-slate-650 mb-2">{t.plekBezetWissel}</p>
        <input
          type="text"
          autoComplete="off"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck={false}
          value={invoer}
          onChange={(e) => setInvoer(e.target.value)}
          placeholder={WISSELWOORD}
          aria-label={t.plekBezetWissel}
          className="w-full p-3 bg-slate-50 border-2 border-slate-250 rounded-xl text-center
                     font-mono text-xl tracking-[0.3em] text-gio-dark placeholder-slate-350
                     focus:outline-none focus:border-gio-orange focus:bg-white
                     transition-colors duration-155"
        />
        <button
          type="submit"
          disabled={!klopt}
          className="w-full mt-2 py-2.5 rounded-xl bg-gio-orange hover:bg-gio-orange-deep text-white
                     font-bold text-sm transition-colors duration-155
                     disabled:opacity-40 disabled:cursor-not-allowed"
        >
          {t.plekBezetKnop}
        </button>
      </form>

      <button
        type="button"
        onClick={terug}
        className="w-full mt-4 py-2.5 rounded-xl border-2 border-slate-250 text-xs font-bold
                   text-slate-550 hover:text-gio-dark hover:border-slate-350
                   transition-colors duration-155"
      >
        {t.terug}
      </button>
    </Kader>
  );
}
